
export default function KeyWordCard({word, arr, setArr}) {
  return (
    <div className='keyWordCard'>
        <p>{word}</p>
        <div onClick={()=>{setArr(arr.filter((item)=>{return item !== word}))}}>X</div>
    </div>
  )
}
